CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_TimeLine, },
], () => {
    let lightdiv = $("<div class='light' style='width: 940px;height: 40px;padding: 10px;'>");
    $("body").append(lightdiv);

    let layoutDiv = $(`
        <div>            
            <div style='position:relative;'>
                <div style='display:inline-block;width:70px;vertical-align:top;'>Time</div>
                <div class='time' style='display:inline-block;width:780px;'></div>
            </div>
        </div>`);

    lightdiv.append(layoutDiv);

    let hour = null;

    layoutDiv.find('.time').css('border', '1px solid #AAAAAA');

    let timeSelector = new CDN.Controls.TimeLine(layoutDiv.find('.time').get(0), {
        intervals: {
            initialValue: 30,
            min: 0,
            max: 60,
        },
        height: "30px",
    });
});